/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'reactstrap';
import {
  XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ComposedChart, Line,
  Label,
} from 'recharts';
import { DefaultTooltipContent } from 'recharts/lib/component/DefaultTooltipContent';
import { colorsCombination, setCurrencyFormat } from '../../../../utils/helpers';

export const CustomTooltip = (props) => {
  // eslint-disable-next-line react/prop-types
  const { active, payload, isSalesKey } = props;
  // we don't need to check payload[0] as there's a better prop for this purpose
  if (!active) {
    // I think returning null works based on this: http://recharts.org/en-US/examples/CustomContentOfTooltip
    return null
  }

  const newPayload = Object.values(payload).sort((a, b) => a.value < b.value ? 1 : -1).map((item) => {
    const updated = { ...item }

    if (item.name === "ACOS") {
      updated.value = `${setCurrencyFormat(Number(item?.value).toFixed(2), false)} %`;
    } else {
      updated.value = setCurrencyFormat(Number(item?.value).toFixed(2), true);
    }

    return updated;
  });

  // we render the default, but with our overridden payload
  return <DefaultTooltipContent {...props} payload={newPayload} />;
};

const AdvCampgainsChart = ({
  dir, dataToPlot, height,
}) => (
  <Col xs={12}>
    <div dir="ltr">
      <ResponsiveContainer height={height}>
        <ComposedChart
          data={dataToPlot}
          margin={{ top: 0, right: 0, left: 25, bottom: 0 }}
        >
          <CartesianGrid vertical={false} horizontal  stroke="#FF0000" strokeWidth={2}  />
          <XAxis dataKey="title" reversed={dir === 'rtl'} />

          <YAxis yAxisId="left" orientation={dir === 'rtl' ? 'right' : 'left'}
            tickFormatter={item => setCurrencyFormat(item, false)}
            width={90} type="number"
            allowDataOverflow >
            <Label angle={-90} value="Value"
              position='insideLeft' style={{ textAnchor: 'middle' }} />
          </YAxis>
          <YAxis yAxisId="right" orientation={dir === 'rtl' ? 'left' : 'right'}
            tickFormatter={item => `${item}%`}
            width={90} type="number"
            allowDataOverflow >
            <Label angle={-90} value="ACOS %"
              position='insideRight' style={{ textAnchor: 'middle' }} />
          </YAxis>
          <Tooltip content={<CustomTooltip
          />}
          />

          <Line dot={false} yAxisId="left" dataKey={"Cost"?.toString()} stroke="#030bfc" />
          <Line dot={false} yAxisId="left" dataKey={"Sales"?.toString()} stroke="#b30790" />
          <Line dot={false} yAxisId="right" dataKey={"ACOS"?.toString()} stroke="#f6da6e" />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  </Col>
);

AdvCampgainsChart.propTypes = {
  dir: PropTypes.string.isRequired,
  dataToPlot: PropTypes.arrayOf({}).isRequired,
  height: PropTypes.number.isRequired,
};


export default AdvCampgainsChart;
